import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { ArrowRightIcon } from "styles/icons";
import NextLink from "next/link";
import { ArrowIcon } from "modules/press/components/PressCoverageItem";
import { DEFAULT_STORY_AUTHOR } from "utils/serverSideUtils/consts";
import { getStoryLastUpdatedDate } from "utils/getStoryLastUpdatedDate";
import PostListImage from "./PostListImage";
import type { PostListItemProps } from "./PostListItem.d";

const { Box, Text, Link } = Chakra;

const PostListItem = ({
  story,
  showImage = true,
  showExcerpt = true,
  showReadMore = true,
  showAuthor = true,
  showDate,
  isHero,
  fallbackFeaturedImage,
  ...props
}: PostListItemProps) => {
  const translations = useTranslations();
  const language = useLanguage();

  const {
    full_slug: fullSlug,
    name,
    content: { featuredImage, author },
  } = story;

  const lastUpdatedDate = showDate ? getStoryLastUpdatedDate(story, language) : "";
  const postTitle = `${name}${!showReadMore ? ArrowIcon : ""}`;

  return (
    <Box mb={{ base: 12, md: 24 }} {...props}>
      <NextLink href={`/${fullSlug}/`} passHref>
        <Link _hover={{ textDecoration: "none" }}>
          {showImage && <PostListImage src={featuredImage ?? fallbackFeaturedImage} alt={name} />}
          <Text
            mb={2}
            color="primary.900"
            fontWeight="bold"
            fontSize={isHero ? { base: "xl", md: "4xl" } : "xl"}
            lineHeight="1.2"
          >
            {postTitle}
          </Text>
          <Box mb={2} color="greyscale.500">
            {showAuthor && (
              <>
                <Text textTransform="lowercase" display="inline">
                  {translations("by_author_name")}
                </Text>
                <Text display="inline">{` ${author || DEFAULT_STORY_AUTHOR}`}</Text>
              </>
            )}
            {showDate && <Text>{lastUpdatedDate}</Text>}
          </Box>
          {showExcerpt && <Text mb={4} color="primary.900" />}
          {showReadMore && (
            <Text fontSize="lg" color="primary.500">
              {translations("read_more")} <ArrowRightIcon boxSize={4} ml={2} />
            </Text>
          )}
        </Link>
      </NextLink>
    </Box>
  );
};

export default PostListItem;
